import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import authService from '../../services/authService';
import AuthMessage from '../AuthMessage/AuthMessage';
import AuthPageLayout from '../AuthPageLayout/AuthPageLayout';
import './ForgotPassword.css';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    if (!email.trim()) {
      setError('Please enter your email or phone number');
      setLoading(false);
      return;
    }

    try {
      const response = await authService.forgotPassword(email);
      
      if (response.success) {
        setSuccess(true);
        setEmail('');
      } else {
        setError(response.message || 'User not found');
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'An error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageLayout>
      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <h2 className="forgot-password-title">RESET PASSWORD</h2>
          
          {success ? (
            <>
              <AuthMessage variant="success">
                A password reset link has been sent to your email. Please check your inbox.
              </AuthMessage>
              <Link to="/signin" className="btn-style-2">
                Back to Login
              </Link>
            </>
          ) : (
            <>
              <AuthMessage variant="info">
                We will send a reset password link to your email or phone number.
              </AuthMessage>

              {error && <AuthMessage variant="error">{error}</AuthMessage>}
              
              <form className="forgot-password-form" onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="emailId"
                  id="emailId"
                  className="input-res"
                  placeholder="Enter your email or phone number"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                  required
                  autoFocus
                />
                
                <button 
                  type="submit" 
                  className="btn-style-2"
                  disabled={loading}
                >
                  {loading ? 'SUBMITTING...' : 'SUBMIT'}
                </button>
                
                <Link to="/signin" className="need-help">
                  Return to Login
                </Link>
              </form>
            </>
          )}
        </div>
      </div>
    </AuthPageLayout>
  );
};

export default ForgotPassword;

